import React from 'react';
import { Participation, StudyType } from '@app/api';
import { CardHomeBase, StyleCardHome } from './CardHomeBase';
import { IconsMeetingList } from './IconsMeetingList';
import { useTranslation } from 'react-i18next';
import { Button, useParticipantUnreadMessageByParticipation } from '@app/core';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  button: {
    width: '100%',
    marginTop: theme.marginBase * 3,
  },
  icons: {
    fontSize: theme.iconSize.large,
    paddingLeft: theme.marginBase,
    alignSelf: 'center',
    fontWeight: 500,
  },
}));

interface Props {
  participation: Participation;
  className: string;
  variant?: 'plain' | 'transparent';
}

export const AcceptedParticipationCard = ({
  className,
  participation,
  variant = 'plain',
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const numberOfNewMessages: number =
    useParticipantUnreadMessageByParticipation(
      participation.participantId,
      participation.id,
    );

  const isUnModerated =
    participation.session?.studyType === StudyType.UNMODERATED;

  const focus = variant === 'plain';

  if (!participation.session) return null;

  return (
    <CardHomeBase
      style={focus ? StyleCardHome.RED : StyleCardHome.WHITE}
      icon={focus ? 'ri-notification-2-line' : undefined}
      title={t('home.profileAccepted.title')}
      className={className}
    >
      <p>
        {t('home.profileAccepted.descriptionNotBold')}{' '}
        {<b>{participation.session.title}</b>}
      </p>
      <IconsMeetingList
        session={participation.session}
        focus={focus}
        participation={participation}
        numberOfNewMessages={numberOfNewMessages}
      />
      <Button
        color={focus ? 'red' : 'blue'}
        variant={focus ? 'plain' : 'muted'}
        className={classes.button}
        to={`/p/${participation.id}`}
        state={{ allowBack: true }}
      >
        {!isUnModerated
          ? t('home.profileAccepted.bookAppointment')
          : t('home.profileAccepted.startStudy')}
        <i className={classnames('ri-calendar-event-line', classes.icons)} />
      </Button>
    </CardHomeBase>
  );
};
